import styled from '@emotion/styled';
import { media } from '../../../style/global-style';

export const StyledFrontpageStage = styled.div<{ background: string }>`
    background: ${(props) => {
        return props.background === 'color'
            ? props.theme.colors.main1
            : `url(${props.background}) no-repeat center center`;
    }};

    width: 100%;
    padding-bottom: 24px;
    text-align: ${(props) => (props.background === 'color' ? 'center' : 'left')};
    background-size: cover;

    ${media.tablet`
        height: 573px;
    `}
    ${media.smallDesktop`
        height: 640px;
    `}
    ${media.bigDesktop`
        width: 1920px;
        height: 550px;
        margin: 0 auto;
    `}
`;

export const StyledHeadlineStage = styled.h1`
    font-size: 32px;
    line-height: 32px;
    padding-top: 4.5%;

    color: ${(props) => props.theme.shades.white};
    ${media.tablet`
        font-size: 54px;
        line-height: 63px;
        text-align: center;
    `}
    ${media.smallDesktop`
        font-size: 104px;
        line-height: 102px;
    `}

    span {
        font-weight: normal;
        font-size: 19px;
        display: block;
        ${media.tablet`
            font-weight: bold;
            font-size: 20px;
        `}
        ${media.smallDesktop`
            font-size: 30px;
        `}
    }
`;
